<script setup>
defineProps({
	label: { type: String, required: true },
	ageRange: { type: String, required: true },
	count: { type: Number, required: true },
	isIncrementDisabled: { type: Boolean, default: false },
	isDecrementDisabled: { type: Boolean, default: false }
});

const emit = defineEmits(['increment', 'decrement']);
</script>

<template>
  <div class="abPassengers__item">
    <div class="abPassengers__group--decoration">
      <span class="abPassengers__type">{{ label }}</span>
      <span class="abPassengers__years">{{ ageRange }}</span>
    </div>
    <div class="abPassengers__group--decoration" role="group">
      <button
        aria-label="minus"
        type="button"
        class="abPassengers__btn"
        :class="{ 'abPassengers__btn--disabled': isDecrementDisabled }"
        role="menuitem"
        tabindex="-1"
        @click="emit('decrement')"
      >
        <i class="icon icon-minus abPassengers__group--icon-counts-decoration" />
      </button>
      <span class="abPassengers__count">{{ count }}</span>
      <button
        aria-label="plus"
        type="button"
        class="abPassengers__btn"
        :class="{ 'abPassengers__btn--disabled': isIncrementDisabled }"
        role="menuitem"
        tabindex="-1"
        @click="emit('increment')"
      >
        <i class="icon icon-plus abPassengers__group--icon-counts-decoration" />
      </button>
    </div>
  </div>
</template>
